import React, { ComponentProps } from 'react';
import { ContentParagraph } from './ContentParagraph';
import { asFetchableView, useViewContext } from '../ViewFetcher';

type PortalSettingsDefaultEmbeddedProps = { value?: string | undefined; content?: string | undefined };

function PortalSettingsDefault({ value, content }: PortalSettingsDefaultEmbeddedProps) {
  const { noContentMessage } = useViewContext();
  return (
    <div className="single-input-block">
      <ContentParagraph>{value || content || noContentMessage}</ContentParagraph>
    </div>
  );
}

export const PortalSettingsDefaultView = asFetchableView(PortalSettingsDefault);
export type PortalSettingsDefaultView = ComponentProps<typeof PortalSettingsDefaultView>;
